import { GridApi } from '@ag-grid-enterprise/all-modules';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import React from 'react';

import { border } from '../../../core/utils/theme.utils';
import { PaginationStateInterface } from '../../../pages/FinancialData/shared/CompanyContext/CompanyContext.types';

interface PaginationProps {
  gridApi: GridApi;
  pagination: PaginationStateInterface;
  onChange: (value: number) => void;
}

const TablePagination: React.FC<PaginationProps> = ({ gridApi, pagination, onChange }) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    gridApi.paginationGoToPage(value - 1);
    onChange(value);
  };

  return (
    <Box className={classes.root}>
      <Pagination
        count={pagination.totalPages}
        page={pagination.page ?? 1}
        onChange={handleChange}
      />
    </Box>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      height: theme.spacing(11),
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
      '& .MuiPagination-root': {
        borderBottom: border(theme.palette.divider),
      },
      '& .MuiPagination-ul': {
        background: theme.palette.secondary.main,
        color: theme.palette.secondary.dark,
        justifyContent: 'center',
        height: theme.spacing(11),
        flexWrap: 'inherit',
      },
      '& .MuiPaginationItem-root': {
        color: theme.palette.secondary.dark,
        borderRadius: 0,
        margin: 0,
        width: theme.spacing(11),
        height: theme.spacing(11),
      },
      '& .MuiPaginationItem-ellipsis': {
        width: '40px',
      },
    },
  }),
);

export default TablePagination;
